export enum NotificationTypeEnum {
    "NotInformed" = 0,
    "Notice" = 1,
    "Billing_Cobranca_Pago" = 11,
    "Billing_Cobranca_Registrado" = 12,
    "Billing_Cobranca_Cancelado" = 13,
    "Billing_Cobranca_Protestado" = 14,
    "Billing_Cobranca_EnviadoCartorio" = 15,
    "Billing_Carteira_TarifasAtualizadas" = 21,
    "Billing_ArquivoRemessa_ErroProcessamento" = 31,
    "Credit_CreditNote_StatusUpdate" = 41,
    "Credit_CreditNote_Liquidation_Success" = 42,
    "Credit_CreditNote_Liquidation_Failure" = 43,
    "Banking_AccountEntry_Success" = 61,
    "Banking_AccountEntry_Failure" = 62,
    "Banking_ReverseAccountEntry_Success" = 63,
    "Banking_ReverseAccountEntry_Failure" = 64,
    "Banking_OpenAccount_Success" = 65,
    "Banking_OpenAccount_Failure" = 66,
    "Banking_AccountClose_Success" = 67,
    "Banking_AccountClose_Failure" = 68,
    "Banking_Transfer_Approval_Success" = 69,
    "Banking_Transfer_Approval_Failure" = 70,
    "Banking_Transfer_Success" = 71,
    "Banking_Transfer_Failure" = 72,
    "Banking_BankSlip_Approval_Success" = 73,
    "Banking_BankSlip_Approval_Failure" = 74,
    "Banking_BankSlip_Payment_Success" = 75,
    "Banking_BankSlip_Payment_Failure" = 76,
    "Banking_Beneficiary_Approval_Pending" = 77,
    "Banking_Beneficiary_Approval_Approved" = 78,
    "Banking_Beneficiary_Approval_Reproved" = 79,
    "Banking_User_Approval_Pending" = 80,
    "Banking_User_Approval_Approved" = 81,
    "Banking_User_Approval_Reproved" = 82,
    "Banking_Transfer_Approval_Pending" = 83,
    "Banking_Transfer_Approval_Approved" = 84,
    "Banking_Transfer_Approval_Reproved" = 85,
    "Banking_Limit_Approval_Pending" = 86,
    "Banking_Limit_Approval_Approved" = 87,
    "Banking_Limit_Approval_Reproved" = 88,
    "Banking_Payment_Approval_Pending" = 89,
    "Banking_Payment_Approval_Approved" = 90,
    "Banking_Payment_Approval_Reproved" = 91,
    "Banking_Approval_Action" = 92
}

export const NotificationTypeDescriptions: { [key in NotificationTypeEnum]: string } = {
    [NotificationTypeEnum.NotInformed]: "Não informado",
    [NotificationTypeEnum.Notice]: "Comunicados",
    [NotificationTypeEnum.Billing_Cobranca_Pago]: "Boletos recebido",
    [NotificationTypeEnum.Billing_Cobranca_Registrado]: "Boletos registrados",
    [NotificationTypeEnum.Billing_Cobranca_Cancelado]: "Boletos cancelados",
    [NotificationTypeEnum.Billing_Cobranca_Protestado]: "Boletos protestados",
    [NotificationTypeEnum.Billing_Cobranca_EnviadoCartorio]: "Boletos enviados para cartório",
    [NotificationTypeEnum.Billing_Carteira_TarifasAtualizadas]: "Tarifas da carteira atualizadas ",
    [NotificationTypeEnum.Billing_ArquivoRemessa_ErroProcessamento]: "Erro de arquivo remessa",
    [NotificationTypeEnum.Credit_CreditNote_StatusUpdate]: "Atualização de status",
    [NotificationTypeEnum.Credit_CreditNote_Liquidation_Success]: "Liquidação realizada",
    [NotificationTypeEnum.Credit_CreditNote_Liquidation_Failure]: "Falha na liquidação",
    [NotificationTypeEnum.Banking_AccountEntry_Success]: "Lançamento realizado",
    [NotificationTypeEnum.Banking_AccountEntry_Failure]: "Falha no lançamento",
    [NotificationTypeEnum.Banking_ReverseAccountEntry_Success]: "Estorno realizado",
    [NotificationTypeEnum.Banking_ReverseAccountEntry_Failure]: "Falha no estorno",
    [NotificationTypeEnum.Banking_OpenAccount_Success]: "Conta aberta",
    [NotificationTypeEnum.Banking_OpenAccount_Failure]: "Falha na abertura de conta",
    [NotificationTypeEnum.Banking_AccountClose_Success]: "Conta encerrada",
    [NotificationTypeEnum.Banking_AccountClose_Failure]: "Falha no encerramento de conta",
    [NotificationTypeEnum.Banking_Transfer_Approval_Success]: "Transferência aprovada",
    [NotificationTypeEnum.Banking_Transfer_Approval_Failure]: "Falha na aprovação de transferência",
    [NotificationTypeEnum.Banking_Transfer_Success]: "Transferência realizada",
    [NotificationTypeEnum.Banking_Transfer_Failure]: "Falha na transferência",
    [NotificationTypeEnum.Banking_BankSlip_Approval_Success]: "Pagamento de boleto aprovado",
    [NotificationTypeEnum.Banking_BankSlip_Approval_Failure]: "Falha na aprovação de pagamento de boleto",
    [NotificationTypeEnum.Banking_BankSlip_Payment_Success]: "Boleto pago",
    [NotificationTypeEnum.Banking_BankSlip_Payment_Failure]: "Falha no pagamento do boleto",

    [NotificationTypeEnum.Banking_Beneficiary_Approval_Pending]: "Aprovação do beneficiário pendente",
    [NotificationTypeEnum.Banking_Beneficiary_Approval_Approved]: "Beneficiário aprovado",
    [NotificationTypeEnum.Banking_Beneficiary_Approval_Reproved]: "Beneficiário reprovado",

    [NotificationTypeEnum.Banking_User_Approval_Pending]: "Aprovação do operador pendente",
    [NotificationTypeEnum.Banking_User_Approval_Approved]: "Operador aprovado",
    [NotificationTypeEnum.Banking_User_Approval_Reproved]: "Operador reprovado",

    [NotificationTypeEnum.Banking_Transfer_Approval_Pending]: "Aprovação da transferência pendente",
    [NotificationTypeEnum.Banking_Transfer_Approval_Approved]: "Transferência aprovada",
    [NotificationTypeEnum.Banking_Transfer_Approval_Reproved]: "Transferência reprovada",

    [NotificationTypeEnum.Banking_Limit_Approval_Pending]: "Aprovação de limite pendente",
    [NotificationTypeEnum.Banking_Limit_Approval_Approved]: "Limite aprovado",
    [NotificationTypeEnum.Banking_Limit_Approval_Reproved]: "Limite reprovado",

    [NotificationTypeEnum.Banking_Payment_Approval_Pending]: "Aprovação de pagamento pendente",
    [NotificationTypeEnum.Banking_Payment_Approval_Approved]: "Pagamento aprovado",
    [NotificationTypeEnum.Banking_Payment_Approval_Reproved]: "Pagamento reprovado",

    [NotificationTypeEnum.Banking_Approval_Action]: "Ação de aprovação executada"
};

export function getNotificationTypeDescription(type: NotificationTypeEnum): string {
    return NotificationTypeDescriptions[type];
}


export const notificationRedirectMap: Map<NotificationTypeEnum | string, string> = new Map([
    // Carteiras
    ["Billing_Billing_Paid", "/gestao-carteira/cobrancas/{id}"],
    ["Billing_Billing_Registered", "/gestao-carteira/cobrancas/{id}"],
    ["Billing_Billing_Cancelled", "/gestao-carteira/cobrancas/{id}"],
    ["Billing_BankSlip_DebtCollectionSuccess", "/gestao-carteira/cobrancas/{id}"],
    ["Billing_BankSlip_DebtCollection", "/gestao-carteira/cobrancas/{id}"],
    ["Billing_FileInstruction_Failure", "/gestao-carteira/carteiras/arquivos/{id}/remessa"],
    ["Billing_Wallet_CostsUpdated", "/gestao-carteira/carteiras/{id}"],
    ["Billing_Wallet_CreatedSuccess", "/gestao-carteira/carteiras/{id}"],
    ["Billing_Wallet_CreatedFailure", "/gestao-carteira/carteiras/{id}"],

    // Crédito
    ["Credit_CreditNote_StatusUpdate", "/ccb/operacoes/{id}"],
    ["Credit_CreditNote_Liquidation_Success", "/ccb/operacoes/{id}"],
    ["Credit_CreditNote_Liquidation_Failure", "/ccb/operacoes/{id}"],

    // Conta digital
    ["Banking_AccountEntry_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_AccountEntry_Failure", "/contas-digitais/ativas/{id}"],
    ["Banking_ReverseAccountEntry_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_ReverseAccountEntry_Failure", "/contas-digitais/ativas/{id}"],
    ["Banking_OpenAccount_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_OpenAccount_Failure", "/contas-digitais/ativas/{id}"],
    ["Banking_AccountClose_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_AccountClose_Failure", "/contas-digitais/ativas/{id}"],

    ["Banking_Transfer_Approval_Success", "/contas-digitais/ativas/{id}/transferencias"],
    ["Banking_Transfer_Approval_Failure", "/contas-digitais/ativas/{id}/transferencias"],
    ["Banking_Transfer_Success", "/contas-digitais/ativas/{id}/transferencias"],
    ["Banking_Transfer_Failure", "/contas-digitais/ativas/{id}/transferencias"],
    ["Banking_Transfer_Approval_Pending", "/aprovacoes/gestao-aprovacoes/internet-banking?typeOfPendingApprovals=BankAccountTransfer"],
    ["Banking_Transfer_Approval_Approved", "/contas-digitais/ativas/{id}/transferencias"],
    ["Banking_Transfer_Approval_Reproved", "/contas-digitais/ativas/{id}/transferencias"],

    ["Banking_BankSlip_Approval_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_BankSlip_Approval_Failure", "/contas-digitais/ativas/{id}"],
    ["Banking_BankSlip_Payment_Success", "/contas-digitais/ativas/{id}"],
    ["Banking_BankSlip_Payment_Failure", "/contas-digitais/ativas/{id}"],

    ["Banking_Beneficiary_Approval_Pending", "/aprovacoes/gestao-aprovacoes/internet-banking?typeOfPendingApprovals=BankAccountBeneficiary"],
    ["Banking_Beneficiary_Approval_Approved", "/contas-digitais/ativas/{id}/favorecidos"],
    ["Banking_Beneficiary_Approval_Reproved", "/contas-digitais/ativas/{id}/favorecidos"],

    ["Banking_User_Approval_Pending", "/aprovacoes/gestao-aprovacoes/internet-banking?typeOfPendingApprovals=BankAccountUser"],
    ["Banking_User_Approval_Approved", "/contas-digitais/ativas/{id}/operadores"],
    ["Banking_User_Approval_Reproved", "/contas-digitais/ativas/{id}/operadores"],

    ["Banking_Limit_Approval_Pending", "/aprovacoes/gestao-aprovacoes/internet-banking?typeOfPendingApprovals=BankAccountTransactionLimits"],
    ["Banking_Limit_Approval_Approved", "/contas-digitais/ativas/{id}/meus-limites"],
    ["Banking_Limit_Approval_Reproved", "/contas-digitais/ativas/{id}/meus-limites"],

    ["Banking_Payment_Approval_Pending", "/aprovacoes/gestao-aprovacoes/internet-banking?typeOfPendingApprovals=BankAccountPayment"],
    ["Banking_Payment_Approval_Approved", "/contas-digitais/ativas/{id}/pagamentos"],
    ["Banking_Payment_Approval_Reproved", "/contas-digitais/ativas/{id}/pagamentos"],

    ["Banking_Approval_Action", "/contas-digitais/ativas/{id}"],
]);
